module.exports = __webpack_public_path__ + "img/casaco-inverno-tommy-jeans.dcad514b.jpg";